import React from 'react';

import { MfaEnrollmentModal } from '../mfa/mfa-enrollment-modal';
import { messages as securityMessages } from '../../pages/settings/sign-in-and-security/sections/security/messages';
import { MANAGEMENT_TYPES } from '../../global/step-up-authentication/constants';

/**
 * @typedef {keyof typeof import('../../authentication/constants').PHONE_VERIFICATION_STATES} PhoneVerificationState
 */

/**
 * Phone verification enrollment component for header notification banner
 * @param {object} props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {() => void} props.onClose - Called when modal should close
 * @param {() => void} props.onSuccess - Called when enrollment succeeds
 * @param {boolean} [props.isUnskippable] - Whether modal is in unskippable state
 * @param {PhoneVerificationState} [props.phoneVerificationState] - Current phone verification state
 * @returns {JSX.Element}
 */
export const PhoneVerificationEnrollment = ({ isOpen, onClose, onSuccess, isUnskippable = false, phoneVerificationState }) => {
  return (
    <MfaEnrollmentModal
      allowMfaTypeSwitching={isUnskippable}
      initialMfaType={MANAGEMENT_TYPES.PHONE}
      isOpen={isOpen}
      isUnskippable={isUnskippable}
      modalTitle={securityMessages.addEnrollmentModalHeader}
      onClose={onClose}
      onSuccess={onSuccess}
      phoneVerificationState={phoneVerificationState}
      restrictToMfaType={MANAGEMENT_TYPES.PHONE}
      showTypeSelection={false}
    />
  );
};
